import React from 'react';
import { Grid, Typography, Button, Box, ButtonBase, Collapse, Switch, Skeleton, LinearProgress } from '@mui/material';
import { MUIDataTableColumnDef, MUIDataTableCustomHeadRenderer } from 'mui-datatables';
import './scss/dinner-table.style.scss';
import _ from 'lodash';
// import FloorPlanComponent from '../../../component/dinner-table';
// import FloorPlanBottomFeature, { GridMode, ScaleAction } from '../../../component/dinner-table/floor-plan.component';
import { apiManage_rbp } from '../../request';
import { Section } from '../../models/section.entity';
import { getTableStatusText } from '../../constants/tool-get-table-status-text';
import { export2Excel, sheetDataType } from '../../constants/utils';
import { Add, ArrowDownward, ArrowUpward, DeleteForever, Remove } from '@mui/icons-material';
import { ReactComponent as DinnerTableAreaTransferIcon } from '../../static/images/svg/dinner-table-area-transfer.svg';
import { ReactComponent as DinnerTableBatchAddIcon } from '../../static/images/svg/dinner-table-batch-add.svg';
/** 与复合型营业时间「添加菜单」等按钮一致：圆角矩形 + 加号（ic:round-plus） */
import { ReactComponent as IcRoundPlusIcon } from '../../static/images/svg/ic_round-plus.svg';
import { TableStatusType } from '../../models/type.constant';
import MenuListComponent, { MenuListItem } from '../dish-menu-creator/menu-list/menu-list-component';
import Table from '../../component/table/table';
import { SectionTable } from '../../models/section-table.entity';
import GlobalNotification from '../../component/common/snackbar';
import i18n from '../../i18n';
import DialogComponent from '../../component/dialog/dialog.component';
import BaseInput from '../../component/form/base-input.component';
import { FormFieldCell } from '../../component/form/form-field-cell.component';
import ButtonComponent from '../../component/button/button.component';
import DeleteDialogComponent from '../../component/dialog/delete-dialog.component';
import AlertDialog from '../../component/dialog/alert-dialog.component';
import setLoading from '../../component/linear-determinate';
import downloadUrl from '../../static/Table.xlsx';

/**
 * 是否属于「未开台」状态（与 getTableStatusText 中 null/-1/0/1 一致，仅此类允许行内调整顺序）
 */
function isDinnerTableUnopenedForSort(tableStatus: TableStatusType | null | undefined): boolean {
    return tableStatus === null || tableStatus === undefined || tableStatus === -1 || tableStatus === 0 || tableStatus === 1;
}

enum DinnerTableDialogType {
    ADD_TABLE = 'ADD_TABLE',
    EDIT_TABLE = 'EDIT_TABLE',
    DELETE_AREA = 'DELETE_AREA',
    DELETE_TABLE = 'DELETE_TABLE',
    EDIT_AREA = 'EDIT_AREA',
    ADD_AREA = 'ADD_AREA',
    MUL_ADD_TABLE = 'MUL_ADD_TABLE',
    TRANSFER_AREA = 'TRANSFER_AREA',
}
class DinnerTablePage extends React.Component<Props, State> {

    touchmoveListener: any;
    public timer: NodeJS.Timeout | null = null;
    public index = 0;
    public tableIds: number[] = [];
    public state: State = {
        isLoading: true,
        dinnerDesks: [],
        tables: [],
        // 选中的菜单
        activeMenu: -1,
        // 列表设置
        total: 0,
        pagPerPage: 20,
        pagPage: 1,
        rowsSelected: [],
        rowsSelectedItem: [],
        // 选中桌台id
        selectedTableId: 0,
        // 新建/编辑桌台弹窗
        showTableDialog: false,
        // 桌台名称（新建/编辑桌台弹窗）
        tableName: '',
        // 桌台状态（新建/编辑桌台弹窗）
        tableStatus: false,
        // 桌台id（编辑桌台弹窗）
        tableId: undefined,
        // 桌台座位数量
        seatNum: 1,
        // 弹窗类型
        dinnerTableDialogType: undefined,
        // 区域名称
        areaName: '',
        // 区域Id
        areaId: undefined,
        // 保存时改成1 控制是否校验无值
        isEmpty: 0,
        // 批量新增桌台数量
        mulAddTableNum: 1,
        mobileTableId: 0,
        subscript: 0,
        // 选中时获取到的桌台状态
        onTableStatus: 0,
        // 弹窗高级设置
        dialogExpanded: false,
        // 二次确认弹窗
        sureDialog: false,
        // 移动区域id
        moveAreaId: undefined,
        // 「顺序调整」开关：开启后表格显示行内上下排序
        isShowUpDownMove: false,
        // 选中的桌台table_id  ids 数组
        rowsSelectedIds: [],
        /** 桌台行内排序请求中：防连点，并与乐观更新后的 init 拉齐 */
        isTableSortPending: false,
    }

    // *********************
    // Life Cycle Function
    // *********************
    async componentDidMount() {
        setLoading(true);
        await this.init(true);
        this.disabledScroll();
        setLoading(false);
        this.setState({ isLoading: false })
    }
    componentWillUnmount() {
        this.touchmoveListener?.remove?.();
    }
    // *********************
    // Default Function
    // *********************

    /**
     * 为了解决平板滑动事件,占用<桌台设置>页面的拖拽效果
     */
    disabledScroll() {
        const dom = document.getElementById('dinner-table-page-content');
        if (dom) {
            this.touchmoveListener?.remove?.();
            this.touchmoveListener = dom?.addEventListener('touchmove', function (e) {
                e.preventDefault(); //阻止默认事件(上下滑动)
            }, { passive: false })//passive防止阻止默认事件不生效
        }
    }
    /**
     * 初始化
     */
    async init(first?: boolean) {
        const result: any = await apiManage_rbp.get_res_tables({ with_section: true });
        if (!result?.error) {
            this.tableIds = [];
            const dinnerDesks: MenuListItem[] = (result || []).map((item: Section) => {
                item.tables?.forEach(table => this.tableIds.push(table.table_id ?? -1))
                return {
                    ...item,
                    key: `${item.rvc_center_id}`,
                    title: `${item.rvc_center_id} - ${item.rvc_center_name}`,
                    dataSource: item,
                    /** 区域内桌台数量，左侧列表角标（Figma 1587:21334） */
                    trailingCount: (item.tables || []).length,
                }
            })
            // 默认显示第一个菜单
            const firstMenu = dinnerDesks?.[0] || {};
            let activeMenu = -1;
            let tables = [];
            if (first) {
                tables = firstMenu.dataSource.tables || [];
                activeMenu = firstMenu.dataSource.rvc_center_id || '';
            } else {
                const menu = _.find(dinnerDesks, (n) => { return n.dataSource.rvc_center_id === this.state.activeMenu });
                activeMenu = menu ? this.state.activeMenu : (firstMenu.dataSource.rvc_center_id || '');
                tables = (menu || firstMenu)?.dataSource.tables || [];
            }
            // 获取列表的最后一位，比较id的大小
            let subscript = 0;
            (dinnerDesks || []).forEach((item: any) => {
                if (item.tables[item.tables.length - 1]?.table_id > subscript) {
                    subscript = item.tables[item.tables.length - 1]?.table_id;
                }
            });
            this.setState({
                dinnerDesks,
                tables,
                activeMenu,
                subscript: subscript + 1,
            })
        }
    }



    /**
     * 记录选中的table，如果存在就删除
     */
    selectTable(data: SectionTable) {
        // 判断是否相同，是取消
        let { selectedTableId } = this.state;
        selectedTableId = selectedTableId === data.table_id ? 0 : data.table_id ?? 0;
        this.setState({ selectedTableId });
    }


    /**
     * 桌台信息
     */
    async onHandelTable(Add: boolean) {
        const { tableName, seatNum, tableStatus, activeMenu, tableId, onTableStatus } = this.state;
        // 新增桌台  添加单个桌台
        if (Add) {
            if (!tableName.trim()) {
                this.setState({ isEmpty: 1 });
                return
            }
            const res = await apiManage_rbp.post_res_table_subscript({
                table_name: tableName,
                seat_num: seatNum,
                rvc_center_id: activeMenu,
                // floor: 1,
                table_status: tableStatus ? 0 : 6,
                cor_status: 1,
                subscript: this.state.subscript
            })
            if (!res?.error) {
                GlobalNotification.success(i18n.t('google_text_create_succeed'))
            } else {
                GlobalNotification.error(i18n.t('google_text_create_failed'))
            }
        } else {
            // 编辑桌台  根据桌台id编辑
            if (tableId) {
                if (!tableName) {
                    this.setState({ isEmpty: 1 });
                    return
                }
                const res = await apiManage_rbp.patch_res_table(tableId, {
                    table_name: tableName,
                    table_status: tableStatus ? onTableStatus : 6,
                    seat_num: seatNum || 0
                })
                if (!res?.error) {
                    GlobalNotification.success(i18n.t('google_text_edit_succeed'))
                } else {
                    GlobalNotification.error(i18n.t('google_text_edit_failed'))
                }
            }
        }

        this.setState({ showTableDialog: false, dialogExpanded: false });
        this.init();
    }

    // 批量新增桌台
    async onHandelMulAddTable() {
        const { seatNum, tableStatus, activeMenu, mulAddTableNum } = this.state;
        const res = await apiManage_rbp.post_mul_res_table({
            seat_num: seatNum,
            rvc_center_id: activeMenu,
            table_status: tableStatus ? 0 : 6,
            cor_status: 1,
            count: mulAddTableNum
        })
        if (!res?.error) {
            GlobalNotification.success(i18n.t('google_text_create_succeed'))

            this.setState({ showTableDialog: false });
            await this.init();
        } else {
            GlobalNotification.error(i18n.t('google_text_create_faile'))
        }
    }
    /**
     * 新建 编辑区域
     */
    async onHandelArea(Add: boolean) {
        const { areaName, areaId } = this.state;
        if (Add) {
            if (!areaName?.trim()) {
                this.setState({ isEmpty: 1 })
                return
            }
            const res = await apiManage_rbp.post_res_area({
                // 区域名称
                rvc_center_name: areaName
            })
            if (!res?.error) {
                GlobalNotification.success(i18n.t('google_text_create_succeed'))
            } else {
                GlobalNotification.error(i18n.t('google_text_create_faile'))
            }
        } else {
            if (areaId) {
                if (!areaName?.trim()) {
                    this.setState({ isEmpty: 1 })
                    return
                }
                const res = await apiManage_rbp.patch_res_area(areaId, {
                    // 区域名称
                    rvc_center_name: areaName
                })
                if (!res?.error) {
                    GlobalNotification.success(i18n.t('google_text_edit_succeed'))
                } else {
                    GlobalNotification.error(i18n.t('google_text_edit_failed'))
                }
            }
        }

        this.setState({ showTableDialog: false }, () => {
            this.init();
        });
    }
    /**
     * 点击菜单
     * - 设置tables
     */
    async setTables(menu: Section) {
        this.setState({ tables: menu?.tables || [], activeMenu: menu?.rvc_center_id || -1, rowsSelected: [] }, async () => {

        });
    }
    /**
     * 获取列表行数据
     */
    getRowItem(selectIndex?: number | number[]) {
        const cloneDeepTables = _.cloneDeep(this.state.tables);
        if (typeof (selectIndex) === 'number') {
            return cloneDeepTables.find((n, iindex) => iindex === selectIndex) as SectionTable;
        } else if (typeof (selectIndex) === 'object') {
            const rowsSelectedItem = cloneDeepTables.filter((item: any, iindex: number) => {
                return selectIndex?.includes(iindex);
            })
            return rowsSelectedItem as SectionTable[];
        }
    }
    /**
     * 弹窗内容设置
     */
    dialogConfig(action: 'CONTENT' | 'TITLE' | 'FUN' = 'FUN') {
        const { moveAreaId, dinnerTableDialogType, tableName, seatNum, isEmpty, mulAddTableNum, dialogExpanded, activeMenu, dinnerDesks } = this.state;
        let content = <div></div>;
        let fun = async () => { };
        let title = '';
        switch (dinnerTableDialogType) {
            case 'ADD_TABLE':
            case 'EDIT_TABLE':
                if (action === 'CONTENT') {
                    content = (
                        <>
                            <Grid sx={{ mb: 2 }}>
                                <FormFieldCell label={i18n.t('dinner_table_page_table_name')}>
                                    <BaseInput
                                        hiddenLabel
                                        variant={'outlined'}
                                        required={true}
                                        regularType={'required'}
                                        value={tableName}
                                        style={{ width: '100%' }}
                                        isEmpty={!!isEmpty}
                                        onChange={(e) => {
                                            this.setState({ tableName: e.target.value })
                                        }}
                                    />
                                </FormFieldCell>
                            </Grid >
                            <Grid sx={{ mb: 2 }}>
                                <FormFieldCell label={i18n.t('dinner_table_page_seat_num')}>
                                    <BaseInput
                                        hiddenLabel
                                        variant={'outlined'}
                                        // required={true}
                                        // regularType={'required'}
                                        type='number'
                                        value={seatNum}
                                        style={{ width: '100%', }}
                                        onChange={(e) => {
                                            if (Number(e.target.value) >= 1) {
                                                this.setState({ seatNum: Number(e.target.value) })
                                            }
                                        }}
                                    />
                                </FormFieldCell>
                            </Grid >
                            {
                                dinnerTableDialogType === 'ADD_TABLE' &&
                                <Grid sx={{ mt: 1 }}>
                                    <div className='collapse-title' style={{ marginBottom: '12px' }}>
                                        <div
                                            onClick={() => this.setState({ dialogExpanded: !dialogExpanded })}
                                            className='collapse-title'
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                        >
                                            {
                                                dialogExpanded ?
                                                    <Remove className='collapse-icon' />
                                                    :
                                                    <Add className='collapse-icon' />
                                            }
                                            <span style={{ fontSize: '16px', fontWeight: 700 }}>{i18n.t('dinner_table_page_advanced_settings')}</span>
                                        </div>
                                        <span className='collapse-tip' style={{ fontSize: '14px' }}>{i18n.t('dinner_table_page_same_table_id_warning_tip')}</span>
                                    </div>
                                    <Collapse in={dialogExpanded}>

                                        <FormFieldCell label={i18n.t('dinner_table_page_table_id')}>
                                            <BaseInput
                                                hiddenLabel
                                                variant={'outlined'}
                                                required={true}
                                                regularType={'required'}
                                                type='number'
                                                value={this.state.subscript}
                                                style={{ width: '100%', marginTop: '12px' }}
                                                onChange={(e) => {
                                                    if (Number(e.target.value) >= 1) {
                                                        this.setState({ subscript: Number(e.target.value) })
                                                    }
                                                }}
                                            />
                                        </FormFieldCell>
                                    </Collapse>
                                </Grid>
                            }
                        </>
                    )
                } else if (action === 'TITLE') {
                    title = i18n.t('dinner_table_page_table_info');
                } else {
                    // 操作桌台
                    fun = async () => {
                        // 新增桌台时，桌台id重复，需要二次确认
                        if (dinnerTableDialogType === 'ADD_TABLE' && this.tableIds.includes(this.state.subscript)) {
                            this.setState({
                                sureDialog: true
                            })
                        } else {
                            await this.onHandelTable(dinnerTableDialogType === 'ADD_TABLE')
                        }
                    };
                }
                break;
            case 'MUL_ADD_TABLE':
                title = i18n.t('dinner_table_page_batch_add_tables')
                content = (
                    <>
                        <Grid>
                            <FormFieldCell label={i18n.t('dinner_table_page_seat_num')}>
                                <BaseInput
                                    hiddenLabel
                                    variant={'outlined'}
                                    required={true}
                                    regularType={'required'}
                                    type='number'
                                    value={seatNum}
                                    style={{ width: '100%', }}
                                    onChange={(e) => {
                                        if (Number(e.target.value) > 0 && Number(e.target.value) <= 10) {
                                            this.setState({ seatNum: Number(e.target.value) })
                                        } else {
                                            this.setState({ seatNum: null })
                                        }
                                    }}
                                />
                            </FormFieldCell>
                        </Grid >
                        <Grid style={{ marginTop: '10px' }}>
                            <FormFieldCell label={i18n.t('dinner_table_page_add_table_amount')}>
                                <BaseInput
                                    hiddenLabel
                                    variant={'outlined'}
                                    required={true}
                                    regularType={'required'}
                                    type='number'
                                    value={mulAddTableNum}
                                    style={{ width: '100%', }}
                                    onChange={(e) => {
                                        if (Number(e.target.value) > 0 && Number(e.target.value) <= 100) {
                                            this.setState({ mulAddTableNum: Number(e.target.value) })
                                        } else {
                                            this.setState({ mulAddTableNum: null })
                                        }
                                    }}
                                />
                            </FormFieldCell>
                        </Grid>
                        {/* <Grid style={{ marginTop: '8px' }}>
                            <Typography className='view-tip-text'>{i18n.t('dinner_table_page_on_use')}</Typography>
                            <IOSSwitch
                                checked={tableStatus}
                                onChange={async () => {
                                    this.setState((state) => {
                                        return {
                                            tableStatus: !state.tableStatus
                                        }
                                    })
                                }}
                            />
                        </Grid > */}
                    </>
                )
                fun = async () => await this.onHandelMulAddTable();
                break;
            case 'ADD_AREA':
            case 'EDIT_AREA':
                if (action === 'CONTENT') {
                    content = (
                        <Grid>
                            <FormFieldCell label={i18n.t('dinner_table_page_table_area_name')}>
                                <BaseInput
                                    hiddenLabel
                                    variant={'outlined'}
                                    required={true}
                                    regularType={'required'}
                                    value={this.state.areaName}
                                    style={{ width: '100%' }}
                                    isEmpty={!!isEmpty}
                                    onChange={(e) => {
                                        this.setState({ areaName: e.target.value })
                                    }}
                                />
                            </FormFieldCell>
                        </Grid >

                    )
                } else if (action === 'TITLE') {
                    title = i18n.t('dinner_table_page_table_area_info');
                } else {
                    fun = async () => { await this.onHandelArea(dinnerTableDialogType === 'ADD_AREA') };
                }
                //  操作区域
                break;
            case 'DELETE_AREA':
            case 'DELETE_TABLE':
                // 确认删除
                if (action === 'CONTENT') {
                    content = <Typography className=''>{i18n.t('dinner_table_page_whether_delete')}</Typography>;
                } else if (action === 'TITLE') {
                    title = i18n.t('dinner_table_page_confirm_delete');

                } else {
                    fun = async () => { await this.deleteTableOrArea(dinnerTableDialogType) };
                }
                break;
            case 'TRANSFER_AREA':
                // 转移桌台区域
                if (action === 'CONTENT') {
                    content = (
                        <Grid>
                            <FormFieldCell label={i18n.t('dinner_table_page_table_area_name')} select>
                                <BaseInput
                                    hiddenLabel
                                    variant={'outlined'}
                                    fullWidth
                                    value={moveAreaId}
                                    onChange={(event: any) => {
                                        this.setState({
                                            moveAreaId: event.target.value
                                        })
                                    }}
                                    select={true}
                                    items={dinnerDesks.filter(desk => Number(desk.key) !== activeMenu).map(item => ({
                                        value: item.key,
                                        label: item.title
                                    }))}
                                />
                            </FormFieldCell>
                        </Grid >
                    )
                } else if (action === 'TITLE') {
                    title = i18n.t('dinner_table_page_text_transfer_table')
                } else {
                    fun = async () => { await this.moveTableArea() };
                }
                break;
            default:
                break;
        }
        if (action === 'CONTENT') {
            return content;
        } else if (action === 'TITLE') {
            return title;
        } else if (action === 'FUN') {
            return fun;
        }
    }
    /**
     * 菜单右键
     */
    handleMenuClick(key: string, menu: any) {
        let dinnerTableDialogType = this.state.dinnerTableDialogType;
        let areaName = '';
        let areaId;
        switch (key) {
            case 'ADD':
                dinnerTableDialogType = DinnerTableDialogType.ADD_AREA;
                break;
            case 'RENAME':
                dinnerTableDialogType = DinnerTableDialogType.EDIT_AREA;
                areaName = menu.rvc_center_name;
                areaId = menu.rvc_center_id;
                break;
            case 'DELETE':
                dinnerTableDialogType = DinnerTableDialogType.DELETE_AREA;
                areaId = menu.rvc_center_id;
                break;
            default:
                dinnerTableDialogType = undefined;
                break;
        }
        if (dinnerTableDialogType) {
            this.setState({
                showTableDialog: true,
                dinnerTableDialogType,
                areaName,
                areaId,
                isEmpty: 0
            })
        }
    }
    /**
     * 删除桌台/区域
     */
    async deleteTableOrArea(dinnerTableDialogType: 'DELETE_AREA' | 'DELETE_TABLE') {
        if (dinnerTableDialogType === 'DELETE_AREA') {
            const { areaId } = this.state;
            if (areaId) {
                const res = await apiManage_rbp.delete_res_area(areaId);
                if (res?.warningStatus === 0) {
                    GlobalNotification.success(i18n.t('google_text_delete_success'));
                } else {
                    GlobalNotification.error(i18n.t('dinner_table_page_delete_failed_area_had_table'));
                }
            }
        } else if (dinnerTableDialogType === 'DELETE_TABLE') {
            const { rowsSelectedIds, rowsSelectedItem } = this.state;
            if (rowsSelectedItem.length) {
                // let errorTable: string[] = [];
                const passTable: string[] = [];
                // await new Promise<void>((resolve, reject) => {
                //     rowsSelectedItem.forEach(async (item, index) => {
                //         // 未开台、已停用
                //         const res = await apiManage_rbp.delete_res_table(item?.table_id);
                //         if (res?.warningStatus === 0) {
                //             passTable.push(item.table_name);
                //         } else {
                //             errorTable.push(item.table_name);
                //         }
                //         if (rowsSelectedItem.length - 1 === index) {
                //             resolve()
                //         }
                //     })
                // })
                // if (errorTable?.length) {
                //     GlobalNotification.error(`${errorTable?.join()} ${i18n.t('dinner_table_page_delete_faild_table_had_used')}`);
                //     passTable.length && GlobalNotification.success(`${passTable?.join()} ${i18n.t('dinner_table_page_detele_table_succeed')}`);
                // } else {
                //     GlobalNotification.success(i18n.t('google_text_delete_success'));
                // }
                // 请求删除接口
                const result = await apiManage_rbp.delete_res_table_batch({ ids: rowsSelectedIds });
                // 删除成功
                if (result?.warningStatus === 0) {
                    rowsSelectedItem.forEach(item => passTable.push(item.table_name));
                    passTable.length && GlobalNotification.success(`${passTable?.join('，')} ${i18n.t('google_text_delete_success')}`);
                } else {
                    GlobalNotification.error(i18n.t('dinner_table_page_delete_faild_table_had_used'));
                }
            }
        }

        this.setState({
            showTableDialog: false,
            rowsSelectedItem: [],
            rowsSelectedIds: [],
            rowsSelected: []
        });
        this.init();
    }

    download() {
        const link = document.createElement('a');
        link.download = `Table.xlsx`;
        link.href = downloadUrl;
        link.click();
    }

    handleExport() {
        const { dinnerDesks } = this.state
        const sheetData: sheetDataType = [{ data: [], sheetName: 'Table' }, { data: [], sheetName: 'Table_Groups' }]
        for (const area of dinnerDesks) {
            sheetData[1].data.push({
                'ID': area.dataSource.rvc_center_id,
                'Name': area.dataSource.rvc_center_name
            })
            for (const item of (area.dataSource.tables || [])) {
                sheetData[0].data.push({
                    'ID': item.table_id,
                    'Name': item.table_name,
                    'GroupName': area.dataSource.rvc_center_name,
                    'TableStatus': 0, // 导出直接变成未开台   OR ==>  getTableStatusText(item.table_status)
                    'SeatNum': item.seat_num
                })
            }
        }
        export2Excel(sheetData, 'Table')
    }

    /**
     * 仅交换当前区域在列表中的两行（浅拷贝新数组，避免 mutating 只读数据）
     */
    swapTableRowsInActiveSection(fromIndex: number, toIndex: number) {
        const { tables, activeMenu, dinnerDesks } = this.state;
        if (fromIndex < 0 || toIndex < 0 || fromIndex >= tables.length || toIndex >= tables.length) {
            return null;
        }
        const newTables = [...tables];
        [newTables[fromIndex], newTables[toIndex]] = [newTables[toIndex], newTables[fromIndex]];
        const newDinnerDesks = dinnerDesks.map((desk) => {
            if (desk.dataSource.rvc_center_id !== activeMenu) {
                return desk;
            }
            return {
                ...desk,
                tables: newTables,
                dataSource: { ...desk.dataSource, tables: newTables },
                /** 与列表行数一致，供侧边栏角标等使用 */
                trailingCount: newTables.length,
            };
        });
        return { tables: newTables, dinnerDesks: newDinnerDesks };
    }

    /**
     * 更改桌台排序：先乐观换行，再调接口，成功后全量 init；失败或异常回滚并提示
     * @param dataIndex 当前行在 tables 中的下标
     * @param direction 与相邻行交换方向（与历史 patch 入参计算方式一致，在乐观更新前取值）
     */
    async onChangeSort(dataIndex: number, direction: 'up' | 'down') {
        const { isTableSortPending, tables, dinnerDesks } = this.state;
        if (isTableSortPending) {
            return;
        }
        if (direction === 'up' && dataIndex === 0) {
            return;
        }
        if (direction === 'down' && dataIndex === tables.length - 1) {
            return;
        }
        // 仅未开台桌台可参与排序，防止绕过 UI
        if (!isDinnerTableUnopenedForSort(tables[dataIndex]?.table_status)) {
            return;
        }
        const toIndex = direction === 'up' ? dataIndex - 1 : dataIndex + 1;
        if (!isDinnerTableUnopenedForSort(tables[toIndex]?.table_status)) {
            return;
        }
        // 与后端约定：下移时 target 可能为「下下行 id」或「下一行 id + 1」
        const originSort = _.get(tables, `[${dataIndex}].table_id`, 0) as number;
        const targetSort =
            direction === 'up'
                ? _.get(tables, `[${toIndex}].table_id`, 0)
                : (_.get(tables, `[${dataIndex + 2}].table_id`) as number) ||
                  ((_.get(tables, `[${dataIndex + 1}].table_id`, 0) as number) + 1);

        const snapshot = {
            tables: _.cloneDeep(tables) as SectionTable[],
            dinnerDesks: _.cloneDeep(dinnerDesks) as MenuListItem[],
        };
        const reordered = this.swapTableRowsInActiveSection(dataIndex, toIndex);
        if (!reordered) {
            return;
        }
        this.setState({
            ...reordered,
            isTableSortPending: true,
        });
        try {
            const result = await apiManage_rbp.patch_table_sort(originSort, targetSort);
            if (result.fieldCount === 0 && result.affectedRows) {
                await this.init();
                this.setState({ isTableSortPending: false });
            } else {
                GlobalNotification.error(result?.result?.details || i18n.t('global_text_operate_failure'));
                this.setState({
                    ...snapshot,
                    isTableSortPending: false,
                });
            }
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
            this.setState({
                ...snapshot,
                isTableSortPending: false,
            });
        }
    }

    /**
     * 移动桌台区域
     */
    async moveTableArea() {
        const { rowsSelectedItem, moveAreaId, dinnerDesks } = this.state;
        if (!moveAreaId || rowsSelectedItem.length === 0) return;
        const tableIds: number[] = rowsSelectedItem.map(item => item.table_id);
        // 目标区域，存在位置的桌台
        const moveAreaTables: SectionTable[] = _.get(dinnerDesks.find(item => _.get(item, 'rvc_center_id') === moveAreaId), 'tables', []).filter((item: SectionTable) => _.isNumber(item.position_x) && _.isNumber(item.position_y));
        let sameMessage: string = '';
        // 判断是否存在位置冲突
        const hasSamePosition: boolean = rowsSelectedItem.some(item => {
            const same = moveAreaTables.find(temp => item.position_x === temp.position_x && item.position_y === temp.position_y);
            if (same) {
                sameMessage = i18n.t('dinner_table_page_has_same_position_error', { x: item.table_name, y: same.table_name });
            }
            return same;
        })
        if (hasSamePosition) {
            return GlobalNotification.error(sameMessage);
        }
        const result = await apiManage_rbp.patch_table_area(tableIds, moveAreaId);
        if (!result?.error) {
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            this.setState({
                moveAreaId: undefined,
                showTableDialog: false,
                rowsSelectedItem: [],
                rowsSelected: []
            })
            await this.init()
        } else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
    }
    /**
     * 上传excel
     * @returns
     */
    onImportExcel() { }

    // *********************
    // View
    // *********************

    render() {
        const { isLoading, dinnerDesks, tables, total, rowsSelected,
            pagPerPage, pagPage,
            showTableDialog, activeMenu, sureDialog, dinnerTableDialogType,
            isTableSortPending,
        } = this.state;
        const isDeleteDialog =
            dinnerTableDialogType === DinnerTableDialogType.DELETE_AREA ||
            dinnerTableDialogType === DinnerTableDialogType.DELETE_TABLE;
        const columns: MUIDataTableColumnDef[] = [
            {
                name: 'table_id',
                label: i18n.t('dinner_table_page_table_id'),
            },
            {
                name: 'table_name',
                label: i18n.t('dinner_table_page_table_name'),
            },
            {
                name: 'table_status',
                label: i18n.t('dinner_table_page_table_status'),
                options: {
                    customBodyRenderLite: (dataIndex: number) => {
                        // 桌台状态（null/0/1未开台，2开台，3已送厨，4已打预结单但未付款，5付款超时，6停用）
                        const status = tables?.[dataIndex]?.table_status ?? null;
                        const isSecondary =
                            status === null || status === -1 || status === 0 || status === 1 || status === 6;
                        return (
                            <Typography
                                component='span'
                                variant='body1'
                                sx={{ color: isSecondary ? 'var(--text-secondary)' : 'var(--func-success)' }}
                            >
                                {getTableStatusText(status)}
                            </Typography>
                        );
                    }
                }
            },
            {
                name: 'seat_num',
                label: i18n.t('dinner_table_page_seat_num'),
            },
            {
                name: 'sort_order',
                label: ' ',
                options: {
                    sort: false,
                    customHeadRender: (columnMeta: MUIDataTableCustomHeadRenderer) => (
                        <th
                            key={columnMeta.name}
                            className='MuiTableCell-root MuiTableCell-head dinner-table-page__sort-col-head'
                            scope='col'
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    gap: 2,
                                    width: '100%',
                                    py: 0.5,
                                    pr: 0.5,
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Typography component='span' sx={{ fontWeight: 500, fontSize: '0.875rem', whiteSpace: 'nowrap' }}>
                                    {i18n.t('dinner_table_page_order_adjust')}
                                </Typography>
                                <Switch
                                    color='primary'
                                    checked={this.state.isShowUpDownMove}
                                    onChange={(_, checked) => this.setState({ isShowUpDownMove: checked })}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </Box>
                        </th>
                    ),
                    customBodyRenderLite: (dataIndex: number) => {
                        const { isShowUpDownMove: orderOn, tables, isTableSortPending: sortBusy } = this.state;
                        const atEnd = dataIndex === (tables.length - 1);
                        const atStart = dataIndex === 0;
                        const rowUnopened = isDinnerTableUnopenedForSort(tables?.[dataIndex]?.table_status);
                        /** 仅能在未开台行之间对调，与下行/上行之一非未开台时禁用对应箭头 */
                        const nextUnopened = atEnd || isDinnerTableUnopenedForSort(tables?.[dataIndex + 1]?.table_status);
                        const prevUnopened = atStart || isDinnerTableUnopenedForSort(tables?.[dataIndex - 1]?.table_status);
                        const iconSx = { fontSize: '1.25rem' };
                        const sortDisabled = !orderOn || sortBusy || !rowUnopened;
                        const canDown = !sortDisabled && !atEnd && nextUnopened;
                        const canUp = !sortDisabled && !atStart && prevUnopened;
                        return (
                            <Box
                                className={`dinner-table-page__sort-cell${orderOn ? '' : ' dinner-table-page__sort-cell--off'}`}
                                sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.5, pr: 1 }}
                            >
                                <ArrowDownward
                                    className={!canDown ? 'dinner-table-page__sort-icon is-muted' : 'dinner-table-page__sort-icon'}
                                    sx={iconSx}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!canDown) {
                                            return;
                                        }
                                        void this.onChangeSort(dataIndex, 'down');
                                    }}
                                />
                                <ArrowUpward
                                    className={!canUp ? 'dinner-table-page__sort-icon is-muted' : 'dinner-table-page__sort-icon'}
                                    sx={iconSx}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!canUp) {
                                            return;
                                        }
                                        void this.onChangeSort(dataIndex, 'up');
                                    }}
                                />
                            </Box>
                        );
                    },
                },
            },

        ]
        // 桌台状态（null/0/1未开台，2开台，3已送厨，4已打预结单但未付款，5付款超时，6停用）
        const disableCheckBoxRow = tables?.map((item, index) => {
            if (item.table_status === 2 || item.table_status === 3 || item.table_status === 4 || item.table_status === 5) {
                return index;
            }
            return null
        }) || [];
        return (
            <Box className='dinner-table-page'>
                <Box className='dinner-table-page__shell'>
                    <Box className='dinner-table-page__sidebar'>
                        <Typography component='h2' className='dinner-table-page__sidebar-title'>
                            {i18n.t('dinner_table_page_label')}
                        </Typography>
                        {isLoading ? (
                            renderDinnerTableSidebarSkeleton()
                        ) : (
                            <MenuListComponent
                                menu={dinnerDesks}
                                activeMenu={`${activeMenu}`}
                                isHideSort={true}
                                surfaceVariant='plain'
                                addButtonPosition='bottom'
                                hideContextMenuAdd
                                renderFooterAdd={() => (
                                    <ButtonBase
                                        className='menu-list__footer-add-area'
                                        disableRipple
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.handleMenuClick('ADD', null);
                                        }}
                                        sx={{
                                            width: '100%',
                                            py: 1,
                                            px: 1,
                                            borderRadius: 1,
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: 1,
                                            color: 'var(--text-secondary)',
                                            '&:hover': { backgroundColor: 'action.hover' },
                                        }}
                                    >
                                        <Typography component='span' variant='body2' sx={{ color: 'inherit', fontWeight: 700 }}>
                                            {i18n.t('dinner_table_page_add_area')}
                                        </Typography>
                                        <Add sx={{ fontSize: '1.125rem', color: 'inherit' }} />
                                    </ButtonBase>
                                )}
                                otherContextMenuOptions={[
                                    {
                                        label: i18n.t('dinner_table_page_rename'),
                                        key: 'RENAME'
                                    }
                                ]}
                                handleClick={async (menu) => {
                                    await this.setTables(menu as Section);
                                }}
                                handleMenuClick={(key, menu) => {
                                    this.handleMenuClick(key, menu);
                                }}
                            />
                        )}
                    </Box>
                    <Box className='dinner-table-page__main' id='dinner-table-page-content'>
                        <Box className='dinner-table-page__toolbar'>
                            <Box className='dinner-table-page__toolbar-row'>
                                <Button
                                    variant='contained'
                                    disableElevation
                                    color='inherit'
                                    className='dinner-table-page__toolbar-btn dinner-table-page__toolbar-btn--primary'
                                    endIcon={(
                                        <Box className='dinner-table-page__toolbar-btn-icon' aria-hidden sx={{ color: 'var(--text-dark)' }}>
                                            <IcRoundPlusIcon />
                                        </Box>
                                    )}
                                    onClick={() => {
                                        this.setState({
                                            showTableDialog: true,
                                            tableName: '',
                                            tableStatus: true,
                                            dinnerTableDialogType: DinnerTableDialogType.ADD_TABLE,
                                            isEmpty: 0
                                        });
                                    }}
                                >
                                    {i18n.t('dinner_table_page_add_table')}
                                </Button>
                                <Button
                                    variant='contained'
                                    disableElevation
                                    color='inherit'
                                    className='dinner-table-page__toolbar-btn dinner-table-page__toolbar-btn--secondary'
                                    endIcon={(
                                        <Box className='dinner-table-page__toolbar-btn-icon' aria-hidden sx={{ color: 'var(--icon-primary-300)' }}>
                                            <DinnerTableBatchAddIcon />
                                        </Box>
                                    )}
                                    onClick={() => {
                                        this.setState({
                                            showTableDialog: true,
                                            tableStatus: true,
                                            dinnerTableDialogType: DinnerTableDialogType.MUL_ADD_TABLE
                                        });
                                    }}
                                >
                                    {i18n.t('dinner_table_page_batch_add_tables')}
                                </Button>
                                <Button
                                    variant='contained'
                                    disableElevation
                                    color='inherit'
                                    className='dinner-table-page__toolbar-btn dinner-table-page__toolbar-btn--secondary'
                                    disabled={rowsSelected?.length === 0}
                                    endIcon={(
                                        <Box className='dinner-table-page__toolbar-btn-icon' aria-hidden>
                                            <DeleteForever sx={{ color: 'var(--icon-primary-300)' }} />
                                        </Box>
                                    )}
                                    onClick={() => {
                                        this.setState({
                                            showTableDialog: true,
                                            dinnerTableDialogType: DinnerTableDialogType.DELETE_TABLE,
                                            isEmpty: 0
                                        });
                                    }}
                                >
                                    {i18n.t('dinner_table_page_delete_table')}
                                </Button>
                                <Button
                                    variant='contained'
                                    disableElevation
                                    color='inherit'
                                    className='dinner-table-page__toolbar-btn dinner-table-page__toolbar-btn--secondary'
                                    disabled={rowsSelected?.length === 0}
                                    endIcon={(
                                        <Box className='dinner-table-page__toolbar-btn-icon' aria-hidden sx={{ color: 'var(--icon-primary-300)' }}>
                                            <DinnerTableAreaTransferIcon />
                                        </Box>
                                    )}
                                    onClick={() => {
                                        this.setState({
                                            showTableDialog: true,
                                            dinnerTableDialogType: DinnerTableDialogType.TRANSFER_AREA,
                                            isEmpty: 0
                                        });
                                    }}
                                >
                                    {i18n.t('dinner_table_page_text_transfer_table')}
                                </Button>
                            </Box>
                        </Box>
                        <Box className='dinner-table-page__table-card' sx={{ position: 'relative' }}>
                            {isTableSortPending && (
                                <LinearProgress
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        zIndex: 1,
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                    }}
                                />
                            )}
                            {isLoading ? (
                                renderDinnerTableListSkeleton()
                            ) : (
                                <Table
                                    centerCellContent
                                    data={tables || []}
                                    columns={columns}
                                    selectableRowsHeader={true}
                                    selectableRowsHideCheckboxes={false}
                                    pagination={true}
                                    rowsSelected={rowsSelected}
                                    onChangePage={(currentPage) => {
                                        this.setState({
                                            pagPage: currentPage + 1
                                        }, async () => {
                                            await this.init();
                                        });
                                    }}
                                    onChangeRowsPerPage={(numberOfRows) => {
                                        this.setState({
                                            pagPerPage: numberOfRows,
                                            pagPage: 1,
                                        }, async () => {
                                            await this.init();
                                        });
                                    }}
                                    otherOption={{
                                        rowsPerPage: pagPerPage,
                                        onChangeRowsPerPage: (nums: number) => {
                                            this.setState({
                                                pagPerPage: nums,
                                            });
                                        },
                                        count: total,
                                        page: pagPage - 1,
                                    }}
                                    onRowSelectionChange={(
                                        currentRowsSelected: any[],
                                        allRowsSelected: any[],
                                        rowsSelected?: any[]
                                    ) => {
                                        rowsSelected = rowsSelected?.filter(item => !disableCheckBoxRow.includes(item));
                                        const rowsSelectedItems = this.getRowItem(rowsSelected) as TableItem[];
                                        const selectedIds = allRowsSelected.map((item) => (_.get(tables, `[${item.dataIndex}].table_id`, 0)));
                                        this.setState({
                                            rowsSelectedIds: selectedIds || [],
                                            rowsSelectedItem: rowsSelectedItems,
                                            rowsSelected: rowsSelected || []
                                        });
                                    }}
                                    onCellClick={(colData, cellMeta: {
                                        colIndex: number;
                                        rowIndex: number;
                                        dataIndex: number;
                                        event: React.MouseEvent<Element, MouseEvent>;
                                    }) => {
                                        /** 含行勾选列时，顺序调整为最后一列（Figma 1587:21334） */
                                        if (cellMeta.colIndex === columns.length) {
                                            return;
                                        }
                                        const rowsSelectedItem = this.getRowItem(cellMeta.dataIndex) as SectionTable;
                                        this.setState({
                                            showTableDialog: true,
                                            tableName: rowsSelectedItem.table_name ?? '',
                                            tableStatus: rowsSelectedItem.table_status !== 6,
                                            tableId: rowsSelectedItem.table_id,
                                            dinnerTableDialogType: DinnerTableDialogType.EDIT_TABLE,
                                            isEmpty: 0,
                                            seatNum: rowsSelectedItem.seat_num || 0,
                                            onTableStatus: rowsSelectedItem.table_status ?? 0,
                                        });
                                    }}
                                    disableCheckBoxRow={disableCheckBoxRow as number[]}
                                />
                            )}
                        </Box>
                    </Box>
                </Box>
                {/* 弹窗 */}
                <DialogComponent
                    className='dinner-table-dialog'
                    open={showTableDialog && !isDeleteDialog}
                    fullWidth={false}
                    onClose={() => { this.setState({ showTableDialog: false, dialogExpanded: false }) }}
                    defaultHeaderProps={{
                        title: this.dialogConfig('TITLE') as string,
                        onClose: () => { this.setState({ showTableDialog: false, dialogExpanded: false }) }
                    }}
                    footer={
                        <div>
                            <Button
                                color='primary'
                                variant='outlined'
                                onClick={() => {
                                    this.setState({ showTableDialog: false, dialogExpanded: false })
                                }}
                            >{i18n.t('google_text_public_button_cancel')}</Button>
                            <Box marginLeft={4} display='inline-block'>
                                <ButtonComponent
                                    variant='contained'
                                    titleText={i18n.t('google_text_confirm')}
                                    handleClick={async () => {
                                        const fun = this.dialogConfig();
                                        if (typeof fun === 'function') {
                                            await fun();
                                        }
                                    }}
                                >
                                    {i18n.t('google_text_confirm')}
                                </ButtonComponent>
                            </Box>
                        </div>
                    }
                >
                    <Grid style={{ padding: '8px' }}>
                        {this.dialogConfig('CONTENT') as JSX.Element}
                    </Grid >
                </DialogComponent >
                <AlertDialog
                    open={showTableDialog && isDeleteDialog}
                    variant="delete"
                    size='xs'
                    title={i18n.t('dinner_table_page_confirm_delete')}
                    desc={i18n.t('dinner_table_page_whether_delete')}
                    onCancel={() => {
                        this.setState({ showTableDialog: false, dialogExpanded: false });
                    }}
                    onConfirm={() => {
                        if (
                            dinnerTableDialogType === DinnerTableDialogType.DELETE_AREA ||
                            dinnerTableDialogType === DinnerTableDialogType.DELETE_TABLE
                        ) {
                            void this.deleteTableOrArea(dinnerTableDialogType);
                        }
                    }}
                />
                {
                    sureDialog &&
                    <DeleteDialogComponent
                        {...{
                            title: i18n.t('google_text_warning'),
                            desc: i18n.t('dinner_table_page_same_table_id_warning'),
                            open: true,
                            onCancel: () => {
                                this.setState({
                                    sureDialog: false
                                })
                            },
                            onConfirm: async () => {
                                await this.onHandelTable(true)
                                this.setState({
                                    sureDialog: false
                                })
                            },
                        }}
                    />
                }
            </Box>

        )
    }
}
export default DinnerTablePage

// *********************
// State & Props
// *********************

type State = {
    dinnerDesks: MenuListItem[];
    tables: SectionTable[];
    isLoading: boolean;
    total: number;
    pagPerPage: number;
    pagPage: number;
    rowsSelected: any[];
    rowsSelectedItem: any[];
    selectedTableId: number;
    showTableDialog: boolean;
    tableName: string;
    tableStatus: boolean;
    tableId: number | undefined;
    seatNum: any;
    activeMenu: number;
    dinnerTableDialogType: DinnerTableDialogType | undefined;
    areaName: string;
    areaId: number | undefined;
    isEmpty: number;
    mulAddTableNum: any;
    // 被移动的桌台
    mobileTableId: number;
    // 添加桌台插入所在下标
    subscript: number;
    // 选中时获取到的桌台状态
    onTableStatus: TableStatusType;
    // 弹窗高级设置
    dialogExpanded: boolean;
    // 二次确认弹窗
    sureDialog: boolean;
    // 移动区域id
    moveAreaId: number | undefined;
    // 「顺序调整」开关：表格行内上下排序列是否展示
    isShowUpDownMove: boolean;
    // 选中的桌台table_id ids 数组
    rowsSelectedIds: number[];
    /** 行内桌台顺序调整请求进行中，用于防重复点击与顶栏进度 */
    isTableSortPending: boolean;
}

type Props = {}

interface TableItem {
    belonged_section_id: number;
    id: number;
    is_disabled: string;
    merged_table_ids: string;
    merged_to_table_id: string | null;
    name: string;
    orderHead: object;
    position_x: number;
    position_y: number;
    status: string;
}

/** 左侧区域列表骨架（加载态） */
function renderDinnerTableSidebarSkeleton(): React.ReactNode {
    return (
        <Box sx={{ px: 0.5, py: 0.5, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
            {Array.from({ length: 7 }).map((_, index) => (
                <Skeleton
                    key={`dinner-table-sidebar-skeleton-${index}`}
                    variant='rounded'
                    height={44}
                    sx={{
                        borderRadius: '10px',
                        width: index % 2 === 0 ? '92%' : '84%',
                    }}
                />
            ))}
            <Skeleton variant='rounded' height={40} sx={{ borderRadius: '10px', mt: 0.5 }} />
        </Box>
    );
}

/** 右侧下方桌台列表骨架（加载态） */
function renderDinnerTableListSkeleton(): React.ReactNode {
    return (
        <Box sx={{ px: 2, py: 1.5 }}>
            <Skeleton variant='rounded' height={40} sx={{ mb: 1.5, borderRadius: '10px' }} />
            {Array.from({ length: 8 }).map((_, index) => (
                <Skeleton
                    key={`dinner-table-list-skeleton-${index}`}
                    variant='rounded'
                    height={36}
                    sx={{ mb: 1, borderRadius: '8px' }}
                />
            ))}
        </Box>
    );
}
